<template>
  <div class="footer">
    <div class="content">
      <div class="link-list">
        <div class="list-item center-item">
          <p class="about"><i class="el-icon-info" /> 关于我们</p>
          <p>关于我们</p>
        </div>
        <div class="list-item center-item">
          <p class="support"><i class="el-icon-question" /> 支持</p>
          <p>FAQ</p>
          <p>反馈</p>
          <p>服务术语</p>
        </div>
        <div class="list-item center-item">
          <p class="other"><i class="el-icon-chat-dot-round" /> 其他</p>
          <p>使用规则</p>
          <p>隐私策略</p>
        </div>
        <div class="list-item center-item">
          <p class="other"><i class="el-icon-chat-dot-round" /> 管理</p>
          <p @click="handleBackstage">工作人员入口</p>
        </div>
      </div>
      <div class="record">
        <p class="record-item"><span class="icon">©</span>版权所有 广州联图电子科技有限公司</p>
        <p class="record-item" @click="handleClick">粤ICP备09162136号</p>
        <p class="record-item">区块链备案号：</p>
        <p class="record-item" @click="handleClickBcn">粤网信备44010623874277540012号 </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handleClick() {
      window.open('https://beian.miit.gov.cn')
    },
    handleBackstage(){
      let schoolId = localStorage.getItem('schoolId');
      window.open('/web/#/login/'+schoolId)
    },
    handleClickBcn() {
      window.open('https://bcbeian.ifcert.cn')
    },
  }
}
</script>
<style lang="less" scoped>
.footer {
  min-width: 1280px;
  height: 250px;
  background: #102244;
}
.content {
  //position: absolute;
  //width: 1920px;
  width: 1200px;
  margin: 0 auto;
  color: #FFFFFF;
}
.link-list {
  //width: 100%;
  //padding: 0 300px;
  display: flex;
  height: 160px;
  color: #FFFFFF;
  .list-item {
    line-height: 35px;
    padding-top: 20px;
  }
  .center-item {
    margin: 0 100px;
  }
  .about, .support, .other {
    font-size: 16px;
  }
}
.record {
  display: flex;
  justify-content: center;
  //justify-content: space-between;
  width: 100%;
  margin: 20px auto;
  font-size: 12px;
  .record-item {
    margin-left: 15px;
    //width: 50%;
    //text-align: center;
  }
  .icon {
    font-size: 16px;
    font-weight: bolder;
    vertical-align: middle;
    padding-right: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/framework/layout/layout-footer.vue